/**
 * A job with ANY interview linked to it — scheduled, in progress, finished, expired or
 * cancelled — is read-only. Its description, configuration, criteria and objectives are
 * what those interviews ran with, so they must not change. The recruiter can still view
 * it and schedule more candidates on exactly that setup, or duplicate it to change it.
 *
 * `total_interviews` is every interview of the job in any state; the server already
 * sends it with every job (list and detail).
 */
export const linkedInterviewCount = (stats) => { var _a; return (_a = stats === null || stats === void 0 ? void 0 : stats.total_interviews) !== null && _a !== void 0 ? _a : 0; };
export const isJdLocked = (stats) => linkedInterviewCount(stats) > 0;
export const JD_LOCKED_MESSAGE = 'This job already has interviews, so it can’t be edited. You can view it and schedule more candidates, or duplicate it to make changes.';
export const jdLockedBannerText = (count) => `This job has ${count} interview${count === 1 ? '' : 's'} linked, so it can’t be edited. ` +
    'You can review every step and schedule more candidates with this setup, or duplicate it to make changes.';
